import { Component, Input, SimpleChanges } from '@angular/core';
import { LazyModuleLoaderModel } from './directive/lazy.model';

@Component({
  selector: 'app-module-loader',
  templateUrl: './module-loader.component.html',
  styleUrls: ['./module-loader.component.scss']
})
export class ModuleLoaderComponent {

  @Input() load;
  @Input() moduleId;
  @Input() selector;
  @Input() inputs;
  @Input() outputs;

  lazyModuleConfig: LazyModuleLoaderModel;


  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.inputs?.currentValue) {
      this.loadLazyModule();
      return;
    } else if ((!changes?.load?.currentValue) || (changes?.load?.currentValue?.toString() === changes?.load?.previousValue?.toString()) || (changes?.load?.currentValue === changes?.load?.previousValue)) {
      return;
    }
    this.loadLazyModule();
  }


  loadLazyModule() {
    if (!this.load) {
      return;
    }
    this.lazyModuleConfig = {
      loader: this.getModulePath(),
    }
  }

  getModulePath() {
    switch (true) {
      case this.moduleId === 'search-bar':
        return () => import('src/app/common/search-bar/search-bar.module');

      case this.moduleId === 'login-popup':
        return () => import('src/app/common/login-popup/login-popup.module');

      case this.moduleId === 'update-tab':
        return () => import('src/app/common/update/update.module');

      case this.moduleId === 'comment-card':
        return () => import('src/app/common/comment-card/comment-card.module');

      case this.moduleId === 'talktous-popup':
        return () => import('src/app/common/common-talktous-modal/common-talktous-modal.module');

      case this.moduleId === 'otp-confirmation':
        return () => import('src/app/common/otp-confirmation/otp-confirmation.module');

      case this.moduleId === 'referral-page-v2':
        return () => import('src/app/referral-page-v2/referral-page-v2.module');

      case this.moduleId === 'fundraiser-thankyou':
        return () => import('src/app/common/fundraiser-thankyou/fundraiser-thankyou.module');

      case this.moduleId === 'impact-signup-card-v4':
        return () => import('src/app/common/impact-signup-card-v4/impact-signup-card-v4.module');

      case this.moduleId === 'impact-signup-card-v5':
        return () => import('src/app/common/impact-signup-card-v5/impact-signup-card-v5.module');

      case this.moduleId === 'impact-signup-card-v6':
        return () => import('src/app/common/impact-signup-card-v6/impact-signup-card-v6.module');

      case this.moduleId === 'impact-signup-card-v7':
        return () => import('src/app/common/impact-signup-card-v7/impact-signup-card-v7.module');

      case this.moduleId === 'sip-goal-v2':
        return () => import('src/app/common/sip-goal-v2/sip-goal-v2.module');

      case this.moduleId === 'pledge-more-typ':
        return () => import('src/app/common/pledge-more-typ/pledge-more-typ.module');

      case this.moduleId === 'thankyou-page-standard':
        return () => import('src/app/common/thankyou-page-standard/thankyou-page-standard.module');

      case this.moduleId === 'impact-thankyou':
        return () => import('src/app/common/impact-thankyou/impact-thankyou.module');

      case this.moduleId === 'sip-quiz-v2':
        return () => import('src/app/common/sip-quiz-v2/sip-quiz-v2.module');

      case this.moduleId === 'sip-thankyou-first':
        return () => import('src/app/common/sip-thankyou-first/sip-thankyou-first.module');

      case this.moduleId === 'sip-thankyou':
        return () => import('src/app/onboard-sip/onboard-sip.module');

      case this.moduleId === 'payment-module':
        return () => import('src/app/common/payment/payment.module');

      case this.moduleId === 'sip-thankyou-v1':
        return () => import('src/app/common/onboarding-sip-v1/onboarding-sip-v1.module');

      case this.moduleId === 'sip-thankyou-v2':
        return () => import('src/app/common/onboarding-v2/onboarding-v2.module');

      case this.moduleId === 'download-app-banner':
        return () => import('src/app/common/download-app-banner/download-app-banner.module');

      case this.moduleId === 'typ-revamp':
        return () => import('src/app/common/typ-revamp/typ-revamp.module');

      case this.moduleId === 'thankyou-loading-header':
        return () => import('src/app/common/thankyou-loading-header/thankyou-loading-header.module');

      case this.moduleId === 'multi-cause-sip-selection':
        return () => import('src/app/common/multi-cause-sip-selection/multi-cause-sip-selection.module');

      case this.moduleId === 'select-live':
        return () => import('src/app/common/select-live/select-live.module');

      case this.moduleId === 'thankyou-page-aftertip':
        return () => import('src/app/common/thankyou-page-aftertip/thankyou-page-aftertip.module');

      case this.moduleId === 'portfolio-agent-nudge':
        return () => import('src/app/common/portfolio-agent-nudge/portfolio-agent-nudge.module');

      case this.moduleId === 'order-reco-card':
        return () => import('src/app/common/order-reco-card/order-reco-card.module');

      case this.moduleId === 'captcha-input':
        return () => import('src/app/common/captcha-input/captcha-input.module');

      case this.moduleId === 'intl-input':
        return () => import('src/app/common/intl-input/intl-input.module');

      case this.moduleId === 'sip-info':
        return () => import('src/app/common/sip-info/sip-info.module');

      case this.moduleId === 'sip-pitch-card-v4':
        return () => import('src/app/common/sip-pitch-card-v4/sip-pitch-card-v4.module');

      case this.moduleId === 'ministory_quiz':
        return () => import('src/app/common/ministory-quiz/ministory-quiz.module');

      case this.moduleId === 'leave-confirmation-dm':
        return () => import('src/app/common/leave-confirmation-dm/leave-confirmation-dm.module');

      case this.moduleId === 'common-header':
        return () => import('src/app/common/common-header/common-header.module');

      case this.moduleId === 'footer':
        return () => import('src/app/common/footer/footer.module');

      case this.moduleId === 'sip-story-banner':
        return () => import('src/app/common/sip-story-banner/sip-story-banner.module');

      case this.moduleId === 'sip-story-pitch-card':
        return () => import('src/app/common/sip-story-pitch-card/sip-story-pitch-card.module');

      case this.moduleId === 'multi-cause-dm':
        return () => import('src/app/common/multi-cause-dm/multi-cause-dm.module');

      case this.moduleId === 'sip-pitch-banner-v2':
        return () => import('src/app/common/sip-pitch-banner-v2/sip-pitch-banner-v2.module');

      case this.moduleId === 'video-dm':
        return () => import('src/app/common/video-dm/video-dm.module');

      case this.moduleId === 'non-login-typ':
        return () => import('src/app/common/non-login-typ/non-login-typ.module');

      case this.moduleId === 'welcome-back-nudge':
        return () => import('src/app/common/welcome-back-nudge/welcome-back-nudge.module');

      case this.moduleId === 'type-delete':
        return () => import('src/app/common/type-delete/type-delete.module');
  
      default:
        break;
    }
  }
}
